export const DASHBOARD_NAV = {
  name: 'Dashboard',
  id: 'dashboard',
  url: '/dashboard',
  icon: 'icon-speedometer'
};

export const PRODUCTS_NAV = {
  name: 'Products',
  id: 'products',
  url: '/products',
  icon: 'icon-grid',
  children: []
};

export const PRODUCTS_NAV_CHILDREN = [
  {
    name: 'Add Products',
    id: 'add_products',
    url: '/products/add-product',
    icon: 'icon-plus'
  },
  {
    name: 'List Products',
    id: 'view_products',
    url: '/products/list-products',
    icon: 'icon-list'
  },
  {
    name: 'Product Replicate',
    id: 'product-replicate',
    url: '/products/product-replicate',
    icon: 'icon-list'
  },
  {
    name: 'Bulk Product Update',
    id: 'edit_products',
    url: '/products/bulk-product-update',
    icon: 'icon-docs'
  },
  {
    name: 'Product Mapping',
    id: 'product_invoice',
    url: '/products/product-invoice',
    icon: 'icon-map'
  },
  {
    name: 'Categories',
    url: '/products/categories',
    id: 'view_category',
    icon: 'icon-layers'
  },
  {
    name: 'Units',
    id: 'view_unit',
    url: '/products/units',
    icon: 'icon-equalizer'
  },
  {
    name: 'Menu',
    id: 'view_menu',
    url: '/products/menu',
    icon: 'icon-doc'
  },
  {
    name: 'Product Serial Stocks',
    id: 'product_serial_stocks',
    url: '/products/product-serial-stocks',
    icon: 'icon-list'
  },
  {
    name: 'Inactive Serial Store',
    id: 'inactive_serial_store',
    url: '/products/inactive-serial-store',
    icon: 'icon-list'
  }
];

export const CASH_REGISTER_NAV = {
  name: 'Cash Register',
  id: 'cash_register',
  icon: 'icon-notebook',
  children: []
};

export const CASH_REGISTER_NAV_CHILDREN = [
  {
    name: 'Manage Cash Register',
    id: 'view_cash_register',
    url: '/cash-register/list',
    icon: 'icon-book-open'
  },
  {
    name: 'Cash Register Audit',
    id: 'view_cash_register_audit',
    url: '/cash-register/audit',
    icon: 'icon-calculator'
  }
];

export const FULFILMENT_NAV = {
  name: 'Fulfilments',
  id: 'fulfilments',
  icon: 'icon-notebook',
  children: []
};

export const FULFILMENT_NAV_CHILDREN = [
  {
    name: 'Fulfilment List',
    id: 'fulfilment_lists',
    url: '/fulfilments/fulfilment-list',
    icon: 'icon-book-open'
  },
  {
    name: 'Stock Request',
    id: 'stock_request',
    url: '/fulfilments/stock-request',
    icon: 'icon-book-open'
  },
  {
    name: 'Digital Stock Request',
    id: 'digital_stock_request',
    url: '/fulfilments/digital-stock-request',
    icon: 'icon-book-open'
  }
];

export const SALES_NAV = {
  name: 'Sales',
  id: 'sales',
  url: '/sales',
  icon: 'icon-chart',
  children: []
};

export const SALES_NAV_CHILDREN = [
  {
    name: 'List Sales',
    id: 'view_sales',
    url: '/sales/list-sales',
    icon: 'icon-pie-chart'
  },
  {
    name: 'Add Sales',
    id: 'add_sales',
    url: '/sales/add-sales',
    icon: 'icon-plus'
  },
  {
    name: 'Used Stocks',
    id: 'used-stock',
    url: '/sales/used-stock',
    icon: 'icon-plus'
  },
  {
    name: 'Make Sales',
    id: 'distributors_sales',
    url: '/sales/distributor-sales',
    icon: 'icon-plus'
  },
  // {
  //   name: 'Fulfillment Center',
  //   id: 'view_sales',
  //   url: '/sales/orders',
  //   icon: 'icon-notebook'
  // }

];

export const PURCHASES_NAV = {
  name: 'Purchases',
  id: 'purchases',
  icon: 'icon-wallet',
  children: []
};

export const PURCHASES_NAV_CHILDREN = [
  {
    name: 'Add Purchase',
    id: 'add_purchases',
    url: '/purchases/add-purchase',
    icon: 'icon-plus'
  },
  {
    name: 'View Purchases',
    id: 'view_purchases',
    url: '/purchases/view-purchases',
    icon: 'icon-book-open'
  },
  // {
  //   name: 'eSim Upload',
  //   url: '/purchases/eSim-upload-lists',
  //   id: 'esim_upload_lists',
  //   icon: 'icon-layers'
  // },
  // {
  //   name: 'presSim Upload',
  //   url: '/purchases/preSim-upload-lists',
  //   id: 'pre_sim_upload_lists',
  //   icon: 'icon-layers'
  // },
];

export const INVENTORY_NAV = {
  name: 'Inventory',
  id: 'inventory',
  url: '/inventory',
  icon: 'icon-tag',
  children: []
};

export const INVENTORY_NAV_CHILDREN = [
  {
    name: 'View Available Stock',
    id: 'view_available_stock',
    url: '/inventory/view-available-stock',
    icon: 'icon-basket'
  },
  {
    name: 'View Serial Stock',
    id: 'view_serial_stock',
    url: '/inventory/view-serial-stock',
    icon: 'icon-layers'
  },
  {
    name: 'Lookup PUK Lists',
    id: 'lookup_puk_lists',
    url: '/inventory/lookup-puk-lists',
    icon: 'icon-magnifier'
  }
];

export const UPLOADS_NAV = {
  name: 'Uploads',
  id: 'uploads',
  url: '/uploads',
  icon: 'icon-tag',
  children: []
};

export const UPLOADS_NAV_CHILDREN = [
  {
    name: 'eSim Upload',
    url: '/uploads/eSim-upload-lists',
    id: 'esim_upload_lists',
    icon: 'icon-layers'
  },
  {
    name: 'preSim Upload',
    url: '/uploads/preSim-upload-lists',
    id: 'pre_sim_upload_lists',
    icon: 'icon-layers'
  },
  // {
  //   name: 'Pre-Esim Upload',
  //   url: '/uploads/pre-esim-upload-lists',
  //   id: 'pre_esim_upload_lists',
  //   icon: 'icon-layers'
  // },
  {
    name: 'Mifi Router Upload',
    url: '/uploads/pre-assign-mifi-router',
    id: 'pre_assign_mifi_router',
    icon: 'icon-layers'
  },
  {
    name: 'Lookup PUK Lists',
    url: '/inventory/lookup-puk-lists',
    id: 'lookup_puk_lists',
    icon: 'icon-magnifier'
  }
];

export const STOCK_TRANSFER_NAV = {
  name: 'Stock Transfer',
  id: 'stock_transfer',
  url: '/stock-transfer',
  icon: 'icon-shuffle',
  children: []
};

export const STOCK_TRANSFER_NAV_CHILDREN = [
  {
    name: 'Add Stock Transfer',
    id: 'add_stock_transfer',
    url: '/stock-transfer/add-stock-transfer',
    icon: 'icon-plus'
  },
  {
    name: 'List Stock Transfer',
    id: 'view_stock_transfer',
    url: '/stock-transfer/list-stock-transfer',
    icon: 'icon-book-open'
  }
];

export const STOCK_ADJUSTMENT_NAV = {
  name: 'Stock Adjustment',
  id: 'stock_adjustment',
  url: '/stock-adjustment',
  icon: 'icon-note',
  children: []
};

export const STOCK_ADJUSTMENT_NAV_CHILDREN = [
  {
    name: 'Add Stock Adjustment',
    id: 'add_stock_adjustment',
    url: '/stock-adjustment/add-stock-adjustment',
    icon: 'icon-plus'
  },
  {
    name: 'List Stock Adjustment',
    id: 'view_stock_adjustment',
    url: '/stock-adjustment/list-stock-adjustment',
    icon: 'icon-book-open'
  }
];

export const STOCK_AUDIT_NAV = {
  name: 'Stock Audit',
  id: 'stock_audit',
  url: '/stock-audit',
  icon: 'icon-calculator',
  children: []
};

export const STOCK_AUDIT_NAV_CHILDREN = [
  {
    name: 'Add Stock Audit',
    id: 'add_stock_audit',
    url: '/stock-audit/add-stock-audit',
    icon: 'icon-plus'
  },
  {
    name: 'List Stock Audit',
    id: 'view_stock_audit',
    url: '/stock-audit/list-stock-audit',
    icon: 'icon-book-open'
  }
];

export const STOCK_WITHDRAWER_NAV = {
  name: 'Stock Withdrawer',
  id: 'stock_withdrawer',
  url: '/stock-withdrawer',
  icon: 'icon-calculator',
  children: []
};

export const STOCK_WITHDRAWER_NAV_CHILDREN = [
  {
    name: 'Partner Stock Withdraw',
    id: 'partner_stock_withdrawer',
    url: '/stock-withdrawer/partner-stock-withdrawer',
    icon: 'icon-plus'
  },
  {
    name: 'View Stock Withdrawer',
    id: 'view_stock_withdrawer',
    url: '/stock-withdrawer/view-stock-withdrawer',
    icon: 'icon-list'
  }
];
export const REPORTS_NAV = {
  name: 'Reports',
  id: 'reports',
  url: '/reports',
  icon: 'icon-chart',
  children: []
};

export const REPORTS_NAV_CHILDREN = [
  {
    name: 'Products',
    id: 'products_report',
    url: '/reports/products',
    icon: 'icon-basket-loaded'
  },
  {
    name: 'Partner Reports',
    id: 'partner_reports',
    url: '/reports/partner-reports',
    icon: 'icon-phone'
  },
  // {
  //   name: 'Locations',
  //   id: 'locations_report',
  //   url: '/reports/locations',
  //   icon: 'icon-location-pin'
  // },
  // {
  //   name: 'Customer Sales',
  //   id: 'customer_sales_report',
  //   url: '/reports/customer-sales',
  //   icon: 'icon-graph'
  // },
  // {
  //   name: 'Direct Sales',
  //   id: 'direct_sales_report',
  //   url: '/reports/direct-sales',
  //   icon: 'icon-bag'
  // },
  {
    name: 'Purchase History',
    id: 'purchase_report',
    url: '/reports/purchase-history',
    icon: 'icon-paypal'
  },
  {
    name: 'Management Reports',
    id: 'management_report',
    url: '/reports/management-report',
    icon: 'icon-bag'
  },
  {
    name: 'Marketing',
    id: 'marketing_report',
    url: '/reports/marketing-reports',
    icon: 'icon-bag'
  },
  {
    name: 'Activities',
    id: 'partners_activities_reports',
    url: '/reports/activities-report',
    icon: 'icon-bag'
  },
  {
    name: 'Accounting',
    id: 'accounting_report',
    url: '/reports/accounting-report',
    icon: 'icon-bag'
  },
  {
    name: 'Regulatory',
    id: 'regulatory_report',
    url: '/reports/regulatory-reports',
    icon: 'icon-bag'
  },
  // {
  //   name: 'Vending',
  //   id: 'vending',
  //   url: '/reports/vending',
  //   icon: 'icon-graph'
  // }
];

export const ACCOUNT_SECTION_BREAKER = {
  title: true,
  name: 'Account'
};

export const ACCOUNTS_NAV = {
  name: 'Accounts',
  id: 'accounts_section',
  icon: 'icon-shield',
  children: []
};

export const ACCOUNTS_NAV_CHILDREN = [
  {
    name: 'Sell Commissions',
    id: 'sell_commissions',
    url: '/settings/sells-commissions',
    icon: 'icon-map'
  },
];

export const PAYMENTS_SECTION_BREAKER = {
  title: true,
  name: 'Payments'
};

export const PAYMENTS_NAV = {
  name: 'Payments',
  id: 'payments',
  icon: 'icon-wallet',
  children: []
};

export const PAYMENTS_NAV_CHILDREN = [
  {
    name: 'Agents LLP',
    id: 'agents_llp',
    url: '/settings/agents-llp',
    icon: 'icon-list'
  },
  {
    name: 'Agents Target',
    id: 'agents_target',
    url: '/settings/agents-target',
    icon: 'icon-list'
  }
];

export const ADMIN_SECTION_BREAKER = {
  title: true,
  name: 'Admin'
};

export const ADMIN_SECTION = {
  name: 'Settings',
  id: 'admin_section',
  url: '/settings/business-location',
  icon: 'icon-settings',
  children: []
};

export const PARTNER_SETTINGS_NAV = {
  name: 'Partners Menu',
  id: 'partner_settings',
  url: '/partner-settings/partner-business-locations',
  icon: 'icon-settings',
  children: []
};
export const PARTNER_SETTINGS_NAV_CHILDREN = [
  // {
  //   name: 'Stocks',
  //   id: 'stocks',
  //   url: '/partner-settings/stocks',
  //   // url: '/settings/business-location',
  //   icon: 'fa fa-book'
  // },
  // {
  //   name: 'Partners',
  //   id: 'create_distributor_partner',
  //   url: '/partner-settings/create-distributor-partner',
  //   // url: '/settings/business-location',
  //   icon: 'icon-people'
  // },
  // {
  //   name: 'Distributors Agents',
  //   id: 'create_distributor_agent',
  //   url: '/partner-settings/create-distributor-agent',
  //   // url: '/settings/business-location',
  //   icon: 'icon-people'
  // },
  {
    name: 'Sub Stores',
    id: 'partner_business_locations',
    url: '/partner-settings/partner-business-locations',
    // url: '/settings/business-location',
    icon: 'icon-map'
  },
  // {
  //   name: 'Partner Agents',
  //   id: 'partner_agent_lists',
  //   url: '/partner-settings/partner-agent-lists',
  //   // url: '/settings/business-location',
  //   icon: 'icon-user'
  // },
  {
    name: 'Agents',
    id: 'partner_user_lists',
    url: '/partner-settings/partner-user-lists',
    // url: '/settings/business-location',
    icon: 'icon-user'
  },
  {
    name: 'Super-Agents',
    id: 'super_agents',
    url: '/partner-settings/partner-super-agent-lists',
    icon: 'icon-user'
  },
  {
    name: 'FSR',
    id: 'fsr',
    url: '/partner-settings/fsr-lists',
    icon: 'icon-people'
  },
  {
    name: 'Wallets',
    id: 'wallets',
    url: '/partner-settings/wallets',
    // url: '/settings/business-location',
    icon: 'icon-wallet'
  },
  // {
  //   name: 'Tier1 Partners',
  //   id: 'tier1_partners',
  //   url: '/partner-settings/tier1-partners',
  //   // url: '/settings/business-location',
  //   icon: 'icon-user'
  // },
  {
    name: 'view-stocks',
    id: 'view_stocks',
    url: '/partner-settings/view-stocks',
    // url: '/settings/business-location',
    icon: 'icon-list'
  },
  {
    name: 'Transaction Logs',
    id: 'transaction-logs',
    url: '/partner-settings/transaction-logs',
    // url: '/settings/business-location',
    icon: 'icon-bag'
  },
  // {
  //   name: 'sales-report',
  //   id: 'sales_report',
  //   url: '/partner-settings/sales-report',
  //   // url: '/settings/business-location',
  //   icon: 'icon-list'
  // },
];
//
// export const ROLES_NAV = {
//   name: 'Roles',
//   id: 'role',
//   icon: 'icon-shield',
//   children: []
// };
//
// export const ROLES_NAV_CHILDREN = [
//   {
//     name: 'Roles',
//     id: 'roles',
//     url: '/settings/roles',
//     icon: 'icon-location-pin'
//   },
//   {
//     name: 'User Lists',
//     id: 'user_lists',
//     url: '/settings/users-lists',
//     icon: 'icon-people'
//   }
// ]

export const SETTINGS_NAV = {
  name: 'Settings',
  id: 'settings',
  url: '/settings/business-location',
  icon: 'icon-settings',
  children: []
};

export const SETTINGS_NAV_CHILDREN = [
  {
    name: 'Business Locations',
    id: 'business_locations',
    url: '/settings/business-locations',
    icon: 'icon-location-pin'
  },
  {
    name: 'User Lists',
    id: 'user_lists',
    url: '/settings/users-lists',
    icon: 'icon-people'
  },
  {
    name: 'Partner Lists',
    id: 'partner_lists',
    url: '/settings/partners-lists',
    icon: 'icon-people'
  },
  {
    name: 'Distributor',
    id: 'allocate_distributor_partners',
    url: '/settings/allocate-distributor-partners',
    icon: 'icon-bag'
  },
  {
    name: 'Business Customers',
    id: 'business_customers',
    url: '/settings/business-customers',
    icon: 'icon-bag'
  },
  {
    name: 'Images',
    id: 'product-image-upload',
    url: '/settings/product-image-upload',
    icon: 'icon-camera'
  },
  {
    name: 'Roles',
    id: 'roles',
    url: '/settings/roles',
    icon: 'icon-organization'
  },
  {
    name: 'Suppliers',
    id: 'contacts',
    url: '/settings/suppliers',
    icon: 'icon-phone'
  },
  {
    name: 'Dispatchs',
    id: 'dispatch',
    url: '/settings/dispatch',
    icon: 'fa fa-truck'
  },
  {
    name: 'manage-plans-matrix',
    id: 'manage_plans_matrix',
    url: '/settings/manage-plans-matrix',
    icon: 'fa fa-book'
  },
  {
    name: 'Manage Data Bundle',
    id: 'manage_data_bundles',
    url: '/settings/manage-data-bundle-plans',
    icon: 'icon-call-in'
  },
  {
    name: 'Product File',
    id: 'product_files',
    url: '/settings/product-file',
    icon: 'icon-doc'
  }
];
